import { useLogout } from "@refinedev/core";
import { LogOut, Menu } from "lucide-react";
import type { AuthUser } from "@/hooks/useAuth";
import { NotificationBell } from "@/components/notifications/NotificationBell";

interface HeaderProps {
  user: AuthUser;
}

export function Header({ user }: HeaderProps) {
  const { mutate: logout } = useLogout();

  return (
    <header className="sticky top-0 z-20 bg-bg-card border-b border-border">
      <div className="container flex items-center gap-3 h-14">
        <button className="md:hidden p-2 -ml-2" aria-label="Menú">
          <Menu className="size-5" />
        </button>

        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium truncate">{user.nombre_completo}</p>
          {user.tienda_nombre && (
            <p className="text-xs text-fg-muted truncate">{user.tienda_nombre}</p>
          )}
        </div>

        <NotificationBell userId={user.id} />

        <button
          onClick={() => logout()}
          className="p-2 text-fg-secondary hover:text-error rounded-md hover:bg-bg"
          aria-label="Salir"
        >
          <LogOut className="size-5" />
        </button>
      </div>
    </header>
  );
}
